import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import {
  getV1OrganizationsByOrganizationIdLeadsOptions,
  getV1OrganizationsByOrganizationIdArchivedLeadsOptions,
} from "../../../client/@tanstack/react-query.gen";
import type { QueryConfig } from "../../utils/query-config";

export const getLeadsOptions = (organizationID: string) => {
  const base = getV1OrganizationsByOrganizationIdLeadsOptions({
    path: { organizationID },
  });
  return queryOptions({
    ...base,
    queryFn: async (ctx) => {
      const label = `[QUERY] getLeads org=${organizationID}`;
      console.time(label);
      const result = await base.queryFn!(ctx);
      console.timeEnd(label);
      console.log(`[QUERY] getLeads count=${Array.isArray(result) ? result.length : "?"}`);
      return result;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGetLeads = (organizationID: string) => {
  return useSuspenseQuery(getLeadsOptions(organizationID));
};

type GetLeadInput = {
  organizationID: string;
  leadID: string;
};

export const useGetLead = (
  { organizationID, leadID }: GetLeadInput,
  config?: QueryConfig,
) => {
  return useSuspenseQuery({
    ...getLeadsOptions(organizationID),
    ...config,
    select: (data) => data.find((lead) => lead.id === leadID),
  });
};

export const useGetArchivedLead = (
  { organizationID, leadID }: GetLeadInput,
  config?: QueryConfig,
) => {
  const base = getV1OrganizationsByOrganizationIdArchivedLeadsOptions({
    path: { organizationID },
  });
  return useSuspenseQuery({
    ...base,
    ...config,
    select: (data) => data.find((lead) => lead.id === leadID),
  });
};
